import { PHONE_SHOWED_STORAGE_KEY } from '../../../constants/lastHopePopup';
import { existNewbuildingIdInStorage } from './existNewbuildingIdInStorage';

export function isUserOpenedPhoneInNewobject(newobjectId: number): boolean {
  return existNewbuildingIdInStorage(PHONE_SHOWED_STORAGE_KEY, newobjectId);
}
